// Ads are disabled by default for AdSense review readiness.
// Re-enable by setting VITE_ADS_ENABLED="true" at build time.
export const ADS_ENABLED = import.meta.env.VITE_ADS_ENABLED === "true";

export const ads = {
    enabledForFreeUsers: true as boolean,
    bannerFrequency: "daily" as "session" | "daily",
    provider: "adsense" as "adsense" | "gpt" | "other",
    networkTagHtml: undefined as string | undefined, // unused for AdSense
  
    adsense: {
      client: "ca-pub-4084661741366623",         // <-- your AdSense client id
      slots: {
        banner: "1234567890",                    // 64px banner (create a 728x90 or 970x90 unit if you want larger; keep our height fixed)
        box: "1234567891",                       // 300x250 / 336x280
      }
    }
  };  